export const getStep = () => {
  const step = document.location.search.replace('?', '').replace(/-/g, '.');
  if (!step || !window.trygTealiumData || !window.trygTealiumData || !window.trygTealiumData.flowHashData || !window.trygTealiumData.flowHashData[`step${step}`]) {
    return null;
  }
  return `step${step}`;
};

export const getStepTitle = () => {
  const step = getStep();
  const stepData = window.trygTealiumData.flowHashData[step];
  // eslint-disable-next-line no-underscore-dangle
  if (stepData && stepData._append_title) {
    // eslint-disable-next-line no-underscore-dangle
    return stepData._append_title;
  }
  return null;
};

export const triggerView = (viewName) => {
  if (window.adobe && window.adobe.target && typeof window.adobe.target.triggerView === 'function') {
    window.adobe.target.triggerView(viewName, { page: false });
  }
};


// WEBPACK FOOTER //
// ./src/utilities/adobeTarget.js